import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { eMenuItems } from 'src/app/core/enums';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { LocationServicesAccessService } from 'src/app/core/services/utelize/access/location-services/location-services-access.service';
import { MdmAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-access.service';
import { MdmHealthReportAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-health-report-access.service';
import { MenuItem } from './menu.model';
import { PlatformInviewMode, PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { RiskIntelligenceAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/risk-intelligence-access.service';
import { SignalsAccessService } from 'src/app/core/services/utelize/access/signals/signals-access.service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TravelRiskManagementAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/travel-risk-management-access.service';

@Component({
  selector: 'app-sidebar-menu-class',
  standalone: true,
  template: ``,
})

export class SideBarMenuComponent implements OnInit {

  get isPlatformModeInview() { return environment.platformModeInview                      ; }
  get showNewDashboard    () { return this.componentAccessUserService.showUsageDashboard(); }

  get showLocationServices    () { return this.locationServicesAccessService    .canShow(); }
  get showMdm                 () { return this.mdmAccessService                 .canShow(); }
  get showMdmDashboard        () { return this.mdmHealthReportAccessService     .canShow(); }
  get showRiskIntelligence    () { return this.riskIntelligenceAccessService    .canShow(); }
  get showTravelRiskManagement() { return this.travelRiskManagementAccessService.canShow(); }

  get showSignals                       () { return this.signalsAccessService.canShow                       (); }
  get showSignalsBreachExposure         () { return this.signalsAccessService.canShowBreachExposure         (); }
  get showSignalsCorporateHealth        () { return this.signalsAccessService.canShowCorporateHealth        (); }
  get showSignalsDashboard              () { return this.signalsAccessService.canShowDashboard              (); }
  get showSignalsDeviceVulnerabilities  () { return this.signalsAccessService.canShowDeviceVulnerabilities  (); }
  get showSignalsTravelRisk             () { return this.signalsAccessService.canShowTravelRisk             (); }
  get showSignalsTravelRiskAdvisories   () { return this.signalsAccessService.canShowTravelRiskAdvisories   (); }
  get showSignalsTravelRiskAlerts       () { return this.signalsAccessService.canShowTravelRiskAlerts       (); }
  get showSignalsTravelRiskComparison   () { return this.signalsAccessService.canShowTravelRiskComparison   (); }
  get showSignalsTravelRiskCountryLevels() { return this.signalsAccessService.canShowTravelRiskCountryLevels(); }
  get showSignalsTravelRiskExposure     () { return this.signalsAccessService.canShowTravelRiskExposure     (); }
  get showSignalsTravelRiskTripBrief    () { return this.signalsAccessService.canShowTravelRiskTripBrief    (); }

  get showLocalRiskLevels () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemLocalRiskLevels,    true); }
  get showTariffsUsage    () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTariffsUsage,       true); }
  get showTravelSearch    () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTravelSearch,       true); }
  get showUserEntitlements() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormManageUserEntitlements, true); }

  get menuTextLinksIntuneDash      () { return this.configSystemService.getValue(ConfigSystemParams.MenuTextLinksIntuneDash,       "Dashboard"   ); }
  get menuTextLinksNPerf           () { return this.configSystemService.getValue(ConfigSystemParams.MenuTextLinksNPerf,            "Speed Test"  ); }
  get menuTextLinksNPerfMap5G      () { return this.configSystemService.getValue(ConfigSystemParams.MenuTextLinksNPerfMap5G,       "5G Map"      ); }
  get menuTextLinksNPerfMapCoverage() { return this.configSystemService.getValue(ConfigSystemParams.MenuTextLinksNPerfMapCoverage, "Coverage Map"); }
  get menuTextLinksNPerfMapSpeed   () { return this.configSystemService.getValue(ConfigSystemParams.MenuTextLinksNPerfMapSpeed,    "Speed Map"   ); }

  get manageEsimVersion2                        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ManageEsimVersion2,                             false); }
  get showAssociates                            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowAssociates,                             false); }
  get showAvailableSims                         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowAvailableSims,                          false); }
  get showCommConfig                            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowCommConfig,                             false); }
  get showDemonstrations                        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowDemonstrations,                         false); }
  get showDeviceManagement                      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DeviceManagementIntune,                         false); }
  get showHelp                                  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowHelp,                                   false); }
  get showInventory                             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.InventoryEnabled,                               false)
                                                             && this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemInventory,                              true )
                                                             && this.modeVisible(false, false, false, true                                                                     ); }
  get showLinks                                 () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowLinks,                                  false); }
  get showLinksNPerf                            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowLinksNPerf,                             false); }
  get showLinksNPerfMap5G                       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowLinksNPerfMap5G,                        false); }
  get showLinksNPerfMapCoverage                 () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowLinksNPerfMapCoverage,                  false); }
  get showLinksNPerfMapSpeed                    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowLinksNPerfMapSpeed,                     false); }
  get showMdmDeviceCampaigns                    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MdmComplianceCampaignsEnabled,                  false) &&
                                                            this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDeviceCampaigns,                     false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDeviceCampaigns,                         true ); }
  get showMdmDeviceCompliance                   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDeviceCompliance,                    false); }
  get showMdmDeviceRemediation                  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MdmRemediationEnabled,                          false) &&
                                                            this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDeviceRemediation,                   false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDeviceRemediation,                       true ); }
  get showMdmDevicesAll                         () { return this.showMdm
                                                            //this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDevicesAll,                          true ) &&
                                                            //this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDevicesAll,                              false)
                                                                                                                                                                                ; }
  get showMdmDevicesCompany                     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDevicesCompany,                      false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDevicesCompany,                          true ); }
  get showMdmDevicesCompanyConfig               () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDevicesCompanyConfig,                false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDevicesCompanyConfig,                    true ); }
  get showMdmDevicesTemplatesCampaigns          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MdmComplianceCampaignsEnabled,                  false) &&
                                                            this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDevicesTemplatesCampaigns,           false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDevicesTemplatesCampaigns,               true ); }
  get showMdmDevicesTemplatesRemediation        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MdmRemediationEnabled,                          false) &&
                                                            this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDevicesTemplatesRemediation,         false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDevicesTemplatesRemediation,             true ); }
  get showMdmDevicesTemplatesRemediationToStatus() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MdmRemediationEnabled,                          false) &&
                                                            this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmDevicesTemplatesRemediationToStatus, false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDevicesTemplatesRemediationToStatus,     true ); }
  get showMdmIntuneSimExceptions                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMdmIntuneSimExceptions,                 false) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmIntuneSimExceptions,                     true ); }
  get showMessaging                             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowMessaging,                              true ) &&
                                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMessaging,                                  true ); }
  get showProvisioningHistory                   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowProvisioningHistory,                    false); }
  get showTemplateMenuItems                     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTemplateMenuItems,                          false); }
  get showTickets                               () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowTickets,                                false); }
  get showTimeline                              () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.MenuShowTimeline,                               false); }
  get showUserWizard                            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowUserWizard,                                 false); }
  get supportPlansEnabled                       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SupportPlansEnabled,                            false); }
   
  private curUser: SystemUserDTO;

  private modeVisible(showForInview  : boolean,
                      showForMdm     : boolean,
                      showForPlatform: boolean,
                      showForSureSim : boolean): boolean {
    try {
      if (!this.isPlatformModeInview)
        return true;

      const mode: PlatformInviewMode=this.platformInviewService.getMode();

      if (mode==='inview')
        return showForInview;

      if (mode==='mdm')
        return showForMdm;

      if (mode==='platform')
        return showForPlatform;

      if (mode==='suresim')
        return showForSureSim;

      return true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  constructor(
    private authenticationService              : AuthenticationService,
    private componentAccessUserService         : ComponentAccessUserService,
    private configSystemService                : ConfigSystemService,
    private exceptionsService                  : ExceptionsService,
    private locationServicesAccessService      : LocationServicesAccessService,
    private mdmAccessService                   : MdmAccessService,
    private mdmHealthReportAccessService       : MdmHealthReportAccessService,
    private platformInviewService              : PlatformInviewService,
    private riskIntelligenceAccessService      : RiskIntelligenceAccessService,
    private signalsAccessService               : SignalsAccessService,
    private travelRiskManagementAccessService  : TravelRiskManagementAccessService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      //CRN_20251222 - This does not fire, this component is controlled by SidebarComponent
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async Init(): Promise<void> {
    try {
      await this.enableFeatures(); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Features
  
  public async enableFeatures(): Promise<void> {
    try {
      await Promise.all([
        this.enableFeatureLocationServices(),
        this.enableFeatureMdm(),
        this.enableFeatureMdmHealthReport(),
        this.enableFeatureRiskIntelligence(),
        this.enableFeatureSignals(),
        this.enableFeatureTravelRiskManagement()
      ]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async enableFeatureLocationServices(): Promise<void> {
    try {
      await this.locationServicesAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public async enableFeatureMdm(): Promise<void> {
    try {
      await this.mdmAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public async enableFeatureMdmHealthReport(): Promise<void> {
    try {
      await this.mdmHealthReportAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async enableFeatureRiskIntelligence(): Promise<void> {
    try {
      await this.riskIntelligenceAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async enableFeatureSignals(): Promise<void> {
    try {
      await this.signalsAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async enableFeatureTravelRiskManagement(): Promise<void> {
    try {
      await this.travelRiskManagementAccessService.ensureInitialised();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public Menu(): MenuItem[] {
    try {
      return [
        {
          id: eMenuItems.title_menu,
          label: 'MENUITEMS.MENU.TEXT',
          isTitle: true,
          visible: this.showTemplateMenuItems,
        },
        {
          id: eMenuItems.title_home,
          label: 'MENUITEMS.HOME_TITLE.TEXT',
          isTitle: true,
          visible: this.modeVisible(true, false, true, true),
        },
        {
          id: eMenuItems.dashboard_dropdown,
          label: 'MENUITEMS.MAINDASHBOARD.TEXT',
          link: '/dashboard-main',
          icon: 'ri-dashboard-line',
          visible: !this.showNewDashboard && this.modeVisible(true, false, true, true),
        },
        {
          id: eMenuItems.dashboard_usage,
          label: 'MENUITEMS.MAINDASHBOARD.TEXT',
          link: '/dashboard-usage',
          icon: 'ri-dashboard-line',
          visible: this.showNewDashboard && this.modeVisible(true, false, true, true),
        },
        {
          id: eMenuItems.timeline_,
          label: 'MENUITEMS.TIMELINE.TEXT',
          link: '/timeline/esim-timeline',
          icon: 'ri-time-line',
          visible: (this.showTimeline || this.curUser.systemAdmin)
                   && this.modeVisible(false, false, false, true),
        },
        {
          id: eMenuItems.location_services,
          label: 'MENUITEMS.LOCATIONSERVICES.TEXT',
          link: '/location-services/company-map',
          icon: 'ri-map-pin-2-line',
          visible: (this.showLocationServices || this.curUser.systemAdmin)
                   && this.modeVisible(false, false, false, true),
        },
        {
          id: eMenuItems.dashboard_dropdown,
          label: 'MENUITEMS.DASHBOARD.TEXT',
          icon: 'ri-dashboard-2-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: eMenuItems.dashboard_analytics,
              label: 'MENUITEMS.DASHBOARD.LIST.ANALYTICS',
              link: '/analytics',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            },
            {
              id: eMenuItems.dashboard_crm,
              label: 'MENUITEMS.DASHBOARD.LIST.CRM',
              link: '/crm',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            },
            {
              id: eMenuItems.dashboard_ecommerce,
              label: 'MENUITEMS.DASHBOARD.LIST.ECOMMERCE',
              link: '/',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            },
            {
              id: eMenuItems.dashboard_crypto,
              label: 'MENUITEMS.DASHBOARD.LIST.CRYPTO',
              link: '/crypto',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            },
            {
              id: eMenuItems.dashboard_projects,
              label: 'MENUITEMS.DASHBOARD.LIST.PROJECTS',
              link: '/projects',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            },
            {
              id: eMenuItems.dashboard_nft,
              label: 'MENUITEMS.DASHBOARD.LIST.NFT',
              link: '/nft',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            },
            {
              id: eMenuItems.dashboard_job,
              label: 'MENUITEMS.DASHBOARD.LIST.JOB',
              link: '/job',
              parentId: eMenuItems.dashboard_dropdown,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: eMenuItems.title_organisation,
          label: 'MENUITEMS.ORGANISATION_TITLE.TEXT',
          isTitle: true,
          visible: this.modeVisible(false, false, false, true),
        },
        {
          id: eMenuItems.companies_dropdown,
          label: 'MENUITEMS.COMPANY_MANAGEMENT.TEXT',
          icon: 'ri-building-2-line',
          link: '/companies/companies',
          // isCollapsed: true,
          visible: this.modeVisible(false, false, false, true),
          subItems: [
            // {
            //   id: eMenuItems.companies,
            //   label: 'MENUITEMS.COMPANY_MANAGEMENT.LIST.COMPANIES',
            //   link: '/companies/companies',
            //   parentId: eMenuItems.companies_dropdown,
            //   visible: true,
            // },
            // {
            //   id: eMenuItems.companies_hierachy,
            //   label: 'MENUITEMS.COMPANY_MANAGEMENT.LIST.COMPANYHIERACHY',
            //   link: '/companies/companies-hierachy',
            //   parentId: eMenuItems.companies_dropdown,
            //   visible: true,
            // },
            // {
            //   id: eMenuItems.companies_portal_access,
            //   label: 'MENUITEMS.COMPANY_MANAGEMENT.LIST.COMPANYPORTALACCESS',
            //   link: '/companies/companies-portal-access',
            //   parentId: eMenuItems.companies_dropdown,
            //   visible: true,
            // },
            // {
            //   id: eMenuItems.companies_component_access,
            //   label: 'MENUITEMS.COMPANY_MANAGEMENT.LIST.COMPANYCOMPONENTACCESS',
            //   link: '/companies/companies-component-access',
            //   parentId: eMenuItems.companies_dropdown,
            //   visible: true,
            // },
          ]
        },
        {
          id: eMenuItems.users_dropdown,
          label: 'MENUITEMS.USER_MANAGEMENT.TEXT',
          icon: 'ri-user-line',
          isCollapsed: true,
          visible: this.modeVisible(false, false, false, true),
          subItems: [
            {
              id: eMenuItems.users_associate,
              label: 'MENUITEMS.USER_MANAGEMENT.LIST.ASSOCIATES',
              link: '/users/users-associate',
              parentId: eMenuItems.users_dropdown,
              visible: this.showAssociates || this.curUser.systemAdmin,
            },
            {
              id: eMenuItems.users_esim,
              label: 'MENUITEMS.USER_MANAGEMENT.LIST.USERS_ESIM',
              link: '/users/users-esim',
              parentId: eMenuItems.users_dropdown,
              visible: true,
            },
            {
              id: eMenuItems.users_portal,
              label: 'MENUITEMS.USER_MANAGEMENT.LIST.USERS_PORTAL',
              link: '/users/users-portal',
              parentId: eMenuItems.users_dropdown,
              visible: true,
            },
            // {
            //   id: eMenuItems.users_component_access,
            //   label: 'MENUITEMS.USER_MANAGEMENT.LIST.USERCOMPONENTACCESS',
            //   link: '/users/users-component-access',
            //   parentId: eMenuItems.users_dropdown,
            //   visible: true,
            // },
            {
              id: eMenuItems.users_add,
              label: 'MENUITEMS.USER_MANAGEMENT.LIST.ADDUSER',
              link: '/users/add-user-wizard',
              parentId: eMenuItems.users_dropdown,
              visible: this.showUserWizard,
            },
          ]
        },
        {
          id: eMenuItems.suppliers_dropdown,
          label: 'MENUITEMS.SUPPLIER_MANAGEMENT.TEXT',
          icon: 'ri-shopping-bag-line',
          isCollapsed: true,
          link: '/suppliers/suppliers',
          visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSupplier)
                   && this.modeVisible(false, false, false, true),
          // subItems: [
          //   {
          //     id: eMenuItems.suppliers,
          //     label: 'MENUITEMS.SUPPLIER_MANAGEMENT.LIST.SUPPLIERS',
          //     link: '/suppliers/suppliers',
          //     parentId: eMenuItems.suppliers_dropdown,
          //     visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSupplierSuppliers),
          //   },
          // ]
        },
        {
          id: eMenuItems.title_communication,
          label: 'MENUITEMS.COMMUNICATION_TITLE.TEXT',
          isTitle: true,
          visible: this.showMessaging,
        },
        {
          id: eMenuItems.communication_messaging,
          label: 'MENUITEMS.COMMUNICATION_MENU.LIST.MESSAGING',
          icon: 'ri-chat-3-line',
          link: '/communication/communication',
          visible: this.showMessaging,
        },
        {
          id: eMenuItems.title_provisioning,
          label: 'MENUITEMS.PROVISIONING_TITLE.TEXT',
          isTitle: true,
          visible: this.modeVisible(false, false, false, true),
        },
        {
          id: eMenuItems.provisioning_devices_dropdown,
          label: 'MENUITEMS.PROVISIONING_DEVICES.TEXT',
          icon: 'ri-sim-card-2-line',
          isCollapsed: true,
          visible: this.modeVisible(false, false, false, true),
          subItems: [
            {
              id: eMenuItems.provisioning_devices_available,
              label: 'MENUITEMS.PROVISIONING_DEVICES.LIST.DEVICE_AVAILABLE',
              link: '/provisioning/devices-available',
              parentId: eMenuItems.provisioning_devices_dropdown,
              visible: this.showAvailableSims
                       && this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemAvailableSims),
            },
            {
              id: eMenuItems.provisioning_devices_allocated,
              label: this.manageEsimVersion2 ? 'MENUITEMS.PROVISIONING_DEVICES.LIST.DEVICE_ALLOCATED_VERSION2'
                                             : 'MENUITEMS.PROVISIONING_DEVICES.LIST.DEVICE_ALLOCATED',
              link: '/provisioning/devices-allocated',
              parentId: eMenuItems.provisioning_devices_dropdown,
              visible: true,
            },
            {
              id: eMenuItems.provisioning_provision_esim,
              label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.ESIM_PROVISION',
              separatorBefore: true,
              link: '/provisioning/esim-provision',
              parentId: eMenuItems.provisioning_devices_dropdown,
              visible: true,
            },
            {
              id: eMenuItems.provisioning_provision_esim_bulk,
              label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.ESIM_BULKPROVISION',
              link: '/provisioning/sim-provision-bulk',
              parentId: eMenuItems.provisioning_devices_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemBulkProvision, true),
            },
          ]
        },
        {
          id: eMenuItems.provisioning_orders_dropdown,
          // label: 'MENUITEMS.PROVISIONING_ORDERS.TEXT',
          label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.HISTORICORDERS',
          icon: 'ri-smartphone-line',
          link: '/provisioning/esim-orders-historic',
          // isCollapsed: true,
          visible: (this.showProvisioningHistory || this.curUser.systemAdmin)
                   && this.modeVisible(false, false, false, true),
          subItems: [
            // {
            //   id: eMenuItems.provisioning_provision_esim,
            //   label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.ESIM_PROVISION',
            //   link: '/provisioning/esim-provision',
            //   parentId: eMenuItems.provisioning_orders_dropdown,
            //   visible: true,
            // },
            // {
            //   id: eMenuItems.provisioning_provision_esim_bulk,
            //   label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.ESIM_BULKPROVISION',
            //   link: '/provisioning/sim-provision-bulk',
            //   parentId: eMenuItems.provisioning_orders_dropdown,
            //   visible: true,
            // },
            // {
            //   id: eMenuItems.provisioning_orders,
            //   label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.ORDERS',
            //   link: '/provisioning/esim-orders',
            //   parentId: eMenuItems.provisioning_orders_dropdown,
            //   visible: true,
            // },
            // {
            //   id: eMenuItems.provisioning_orders_historic,
            //   label: 'MENUITEMS.PROVISIONING_ORDERS.LIST.HISTORICORDERS',
            //   link: '/provisioning/esim-orders-historic',
            //   parentId: eMenuItems.provisioning_orders_dropdown,
            //   visible: true,
            // },
          ]
        },
        {
          id: eMenuItems.title_mdm,
          label: 'MENUITEMS.MDM_TITLE.TEXT',
          isTitle: true,
          visible: (this.showMdm && this.modeVisible(false, true, false, false))
                   || this.showInventory,
        },
        {
          id: eMenuItems.inventory,
          label: 'MENUITEMS.INVENTORY.TEXT',
          icon: 'ri-archive-line',
          link: '/device-management/inventory',
          visible: this.showInventory,
        },
        {
          id: eMenuItems.mdm_intune_dropdown,
          label: 'MENUITEMS.MDM_TYPES.LIST.MDM_INTUNE',
          icon: 'bi bi-microsoft', //'assets/images/_images/microsoft-intune.png',
          isCollapsed: true,
          visible: this.showMdm
                   && this.modeVisible(false, true, false, false),
          subItems: [
            {
              id: eMenuItems.mdm_intune_dashboard,
              //label: 'MENUITEMS.MDM_TYPES.LIST.MDM_INTUNE_DASHBOARD',
              label: this.menuTextLinksIntuneDash,
              link: '/device-management/mdm-dashboard',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.showMdmDashboard,
              separatorAfter: true,
            },
            {
              id: eMenuItems.mdm_device_compliance,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICE_COMPLIANCE',
              link: '/device-management/mdm-device-compliance',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.showMdmDeviceCompliance,
            },
            {
              id: eMenuItems.mdm_intune_devices,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_INTUNE_DEVICES',
              link: '/device-management/mdm-devices-intune',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.showMdmDevicesAll,
            },
            {
              id: eMenuItems.mdm_device_remediation,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICE_REMEDIATION',
              link: '/device-management/mdm-device-remediation',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.showMdmDeviceRemediation,
            },
            {
              id: eMenuItems.mdm_intune_sim_exceptions,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_INTUNE_SIM_EXCEPTIONS',
              link: '/device-management/mdm-intune-sim-exceptions',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.showMdmIntuneSimExceptions,
            },
            {
              id: eMenuItems.mdm_logs,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_LOGS',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.showMdmDeviceCampaigns || this.showMdmDeviceRemediation,
              subItems: [
                {
                  id: eMenuItems.mdm_device_compliance_logs,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_LOGS_CAMPAIGN',
                  link: '/device-management/mdm-device-compliance-logs',
                  parentId: eMenuItems.mdm_logs,
                  isCollapsed: true,
                  visible: this.showMdmDeviceCampaigns,
                },
                {
                  id: eMenuItems.mdm_device_notification_logs,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_LOGS_NOTIFICATION_AND_STATUS',
                  link: '/device-management/mdm-device-notification-logs',
                  parentId: eMenuItems.mdm_logs,
                  isCollapsed: true,
                  visible: this.showMdmDeviceRemediation,
                },
              ]
            },
            {
              id: eMenuItems.mdm_intune_users,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_INTUNE_USERS',
              link: '/device-management/mdm-users-intune',
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemMdmDeviceUsers, true),
            },
            {
              id: eMenuItems.mdm_devices_company_settings,
              label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICES_COMPANY_SETTINGS',
              separatorBefore: true,
              parentId: eMenuItems.mdm_intune_dropdown,
              isCollapsed: true,
              visible:    this.showMdmDevicesCompany
                       || this.showMdmDevicesCompanyConfig
                       || this.showMdmDevicesTemplatesCampaigns
                       || this.showMdmDevicesTemplatesRemediation
                       || this.showMdmDevicesTemplatesRemediationToStatus,
              subItems: [
                {
                  id: eMenuItems.mdm_devices_company_config,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICES_COMPANY_CONFIG',
                  link: '/device-management/mdm-devices-company-config',
                  parentId: eMenuItems.mdm_devices_company_settings,
                  isCollapsed: true,
                  visible: this.showMdmDevicesCompanyConfig,
                },
                {
                  id: eMenuItems.mdm_compliance_campaigns,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_COMPLIANCE_CAMPAIGNS',
                  link: '/device-management/mdm-compliance-campaigns',
                  parentId: eMenuItems.mdm_devices_company_settings,
                  isCollapsed: true,
                  visible: this.showMdmDeviceCampaigns,
                },
                {
                  id: eMenuItems.mdm_devices_company,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICES_COMPANY',
                  link: '/device-management/mdm-devices-company',
                  parentId: eMenuItems.mdm_devices_company_settings,
                  isCollapsed: true,
                  visible: this.showMdmDevicesCompany,
                },
                {
                  id: eMenuItems.mdm_devices_templates_compliance_campaigns,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICES_TEMPLATES_COMPLIANCE_CAMPAIGNS',
                  link: '/device-management/mdm-devices-templates-compliance-campaigns',
                  parentId: eMenuItems.mdm_devices_company_settings,
                  isCollapsed: true,
                  visible: this.showMdmDevicesTemplatesCampaigns,
                },
                {
                  id: eMenuItems.mdm_devices_templates_remediation,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICES_TEMPLATES_REMEDIATION',
                  link: '/device-management/mdm-devices-templates-remediation',
                  parentId: eMenuItems.mdm_devices_company_settings,
                  isCollapsed: true,
                  visible: this.showMdmDevicesTemplatesRemediation,
                },
                {
                  id: eMenuItems.mdm_devices_templates_remediation_to_status,
                  label: 'MENUITEMS.MDM_TYPES.LIST.MDM_DEVICES_TEMPLATES_REMEDIATION_TO_STATUS',
                  link: '/device-management/mdm-devices-templates-remediation-to-status',
                  parentId: eMenuItems.mdm_devices_company_settings,
                  isCollapsed: true,
                  visible: this.showMdmDevicesTemplatesRemediationToStatus,
                },
              ]
            },
          ]
        },
        {
          id: eMenuItems.title_reporting,
          label: 'MENUITEMS.REPORTING_TITLE.TEXT',
          isTitle: true,
          visible: this.modeVisible(false, false, false, true), //this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemReports),
        },
        {
          id: eMenuItems.reporting_financial_dropdown,
          label: 'MENUITEMS.REPORTING_FINANCIAL.TEXT',
          link: '/reporting/reporting-financial',
          icon: 'ri-file-list-3-line',
          visible: this.modeVisible(false, false, false, true), //this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemReports),
          // subItems: [
          //   {
          //     id: eMenuItems.reporting_financial,
          //     label: 'MENUITEMS.REPORTING_FINANCIAL.LIST.FINANCIAL',
          //     link: '/reporting/reporting-financial',
          //     parentId: eMenuItems.reporting_financial_dropdown,
          //     visible: true,
          //   }
          // ]
        },
        {
          id: eMenuItems.title_risk_intelligence,
          label: 'MENUITEMS.RISK_INTELLIGENCE_TITLE.TEXT',
          isTitle: true,
          visible: this.showRiskIntelligence,
        },
        {
          id: eMenuItems.risk_intelligence_travel_risk_management,
          label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.TRAVEL_RISK_MANAGEMENT',
          icon: 'ri-earth-line',
          link: '/risk-intelligence/travel-risk-management',
          visible: this.showTravelRiskManagement,
        },
        {
          id: eMenuItems.risk_intelligence_dropdown,
          label: 'MENUITEMS.RISK_INTELLIGENCE.TEXT',
          icon: 'ri-shield-star-line',
          isCollapsed: true,
          visible: this.showRiskIntelligence,
          subItems: [
            {
              id: eMenuItems.risk_intelligence_trip_ready,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.TRIP_READY',
              link: '/risk-intelligence/trip-ready',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: true,
              separatorAfter: true,
            },
            {
              id: eMenuItems.risk_intelligence_advisories,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.ADVISORIES',
              link: '/risk-intelligence/advisories',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: false,
            },
            {
              id: eMenuItems.risk_intelligence_alerts,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.ALERTS',
              link: '/risk-intelligence/alerts',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: true,
            },
            {
              id: eMenuItems.risk_intelligence_city_reports,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.CITY_REPORTS',
              link: '/risk-intelligence/city-reports',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: true,
            },
            {
              id: eMenuItems.risk_intelligence_country_risk_levels,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.COUNTRY_RISK_LEVELS',
              link: '/risk-intelligence',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: true,
            },
            {
              id: eMenuItems.risk_intelligence_local_risk_levels,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.LOCAL_RISK_LEVELS',
              link: '/risk-intelligence/local-risk-levels',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: this.showLocalRiskLevels,
            },
            {
              id: eMenuItems.risk_intelligence_travel_search,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.TRAVEL_SEARCH',
              link: '/risk-intelligence/travel-search',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: this.showTravelSearch,
            },
            {
              id: eMenuItems.risk_intelligence_usage_report,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.USAGE_REPORT',
              link: '/risk-intelligence/usage-report',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: this.showUserEntitlements,
            },
            {
              id: eMenuItems.risk_intelligence_user_entitlements,
              label: 'MENUITEMS.RISK_INTELLIGENCE.LIST.USER_ENTITLEMENTS',
              link: '/risk-intelligence/user-entitlements',
              parentId: eMenuItems.risk_intelligence_dropdown,
              visible: this.showUserEntitlements,
            },
          ]
        },
        {
          id: eMenuItems.signals_dropdown,
          label: 'MENUITEMS.SIGNALS.TEXT',
          icon: 'ri-radar-line',
          isCollapsed: true,
          visible: this.showSignals,
          subItems: [
            {
              id: eMenuItems.signals_dashboard,
              label: 'MENUITEMS.SIGNALS.LIST.DASHBOARD',
              link: '/signals/dashboard',
              parentId: eMenuItems.signals_dropdown,
              visible: this.showSignalsDashboard,
              separatorAfter: true,
            },
            {
              id: eMenuItems.signals_breach_exposure,
              label: 'MENUITEMS.SIGNALS.LIST.BREACH_EXPOSURE',
              link: '/signals/breach-exposure',
              parentId: eMenuItems.signals_dropdown,
              visible: this.showSignalsBreachExposure,
            },
            {
              id: eMenuItems.signals_corporate_health,
              label: 'MENUITEMS.SIGNALS.LIST.CORPORATE_HEALTH',
              link: '/signals/corporate-health',
              parentId: eMenuItems.signals_dropdown,
              visible: this.showSignalsCorporateHealth,
            },
            {
              id: eMenuItems.signals_device_vulnerabilities,
              label: 'MENUITEMS.SIGNALS.LIST.DEVICE_VULNERABILITIES',
              link: '/signals/device-vulnerabilities',
              parentId: eMenuItems.signals_dropdown,
              visible: this.showSignalsDeviceVulnerabilities,
            },
            {
              id: eMenuItems.signals_travel_risk_dropdown,
              label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.TEXT',
              parentId: eMenuItems.signals_dropdown,
              visible: this.showSignalsTravelRisk,
              subItems: [
                {
                  id: eMenuItems.signals_travel_risk_advisories,
                  label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.ADVISORIES',
                  link: '/signals/travel-risk/advisories',
                  parentId: eMenuItems.signals_travel_risk_dropdown,
                  visible: this.showSignalsTravelRiskAdvisories,
                },
                {
                  id: eMenuItems.signals_travel_risk_alerts,
                  label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.ALERTS',
                  link: '/signals/travel-risk/alerts',
                  parentId: eMenuItems.signals_travel_risk_dropdown,
                  visible: this.showSignalsTravelRiskAlerts,
                },
                {
                  id: eMenuItems.signals_travel_risk_country_levels,
                  label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.COUNTRY_RISK_LEVELS',
                  link: '/signals/travel-risk/country',
                  parentId: eMenuItems.signals_travel_risk_dropdown,
                  visible: this.showSignalsTravelRiskCountryLevels,
                },
                {
                  id: eMenuItems.signals_travel_risk_exposure,
                  label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.EXPOSURE',
                  link: '/signals/travel-risk/exposure',
                  parentId: eMenuItems.signals_travel_risk_dropdown,
                  visible: this.showSignalsTravelRiskExposure,
                },
                {
                  id: eMenuItems.signals_travel_risk_comparison,
                  label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.DERIVATION',
                  link: '/signals/travel-risk/derivation',
                  parentId: eMenuItems.signals_travel_risk_dropdown,
                  visible: this.showSignalsTravelRiskComparison,
                },
                {
                  id: eMenuItems.signals_travel_risk_trip_brief,
                  label: 'MENUITEMS.SIGNALS.LIST.TRAVEL_RISK.TRIP_BRIEF',
                  link: '/signals/travel-risk/trip-brief',
                  parentId: eMenuItems.signals_travel_risk_dropdown,
                  visible: this.showSignalsTravelRiskTripBrief,
                },
              ]
            },
          ]
        },
        {
          id: eMenuItems.title_billing,
          label: 'MENUITEMS.BILLING_TITLE.TEXT',
          isTitle: true,
          visible: (this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTariffs, true)
                    || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemInvoice))
                   && this.modeVisible(false, false, false, true),
        },
        // {
        //   id: eMenuItems.tariffs_dropdown,
        //   label: 'MENUITEMS.TARIFFS.TEXT',
        //   icon: 'ri-increase-decrease-line',
        //   isCollapsed: true,
        //   visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTariffs)
        //            && this.modeVisible(false, false, false, true),
        //   subItems: [
        //     {
        //       id: eMenuItems.tariffs_rental,
        //       label: 'MENUITEMS.TARIFFS.LIST.RENTAL.TEXT',
        //       parentId: eMenuItems.tariffs_dropdown,
        //       isCollapsed: true,
        //       visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTariffsRental),
        //       subItems: [
        //         {
        //           id: eMenuItems.tariffs_rental_tariffs,
        //           label: 'MENUITEMS.TARIFFS.LIST.RENTAL.RENTAL_TARIFFS',
        //           link: '/tariffs/tariffs-rental',
        //           parentId: eMenuItems.tariffs_rental,
        //           visible: true,
        //         },
        //         // {
        //         //   id: eMenuItems.tariffs_rental_tariffs_details,
        //         //   label: 'MENUITEMS.TARIFFS.LIST.RENTAL.RENTAL_TARIFFS_DETAILS',
        //         //   link: '/tariffs/tariffs-rental-details',
        //         //   parentId: eMenuItems.tariffs_rental,
        //         //   visible: true,
        //         // },
        //         {
        //           id: eMenuItems.tariffs_rental_tariff_bands,
        //           label: 'MENUITEMS.TARIFFS.LIST.RENTAL.RENTAL_TARIFFS_BANDS',
        //           link: '/tariffs/tariffs-rental-bands',
        //           parentId: eMenuItems.tariffs_rental,
        //           visible: true,
        //         }
        //       ]
        //     },
        //     {
        //       id: eMenuItems.tariffs_usage,
        //       label: 'MENUITEMS.TARIFFS.LIST.USAGE.TEXT',
        //       parentId: eMenuItems.tariffs_dropdown,
        //       isCollapsed: true,
        //       visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTariffsUsage),
        //       subItems: [
        //         {
        //           id: eMenuItems.tariffs_usage_tariffs,
        //           label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_TARIFFS',
        //           link: '/tariffs/tariffs-usage',
        //           parentId: eMenuItems.tariffs_usage,
        //           visible: true,
        //         },
        //         {
        //           id: eMenuItems.tariffs_usage_tariff_zones,
        //           label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_TARIFFS_ZONES',
        //           link: '/tariffs/tariffs-usage-zones',
        //           parentId: eMenuItems.tariffs_usage,
        //           visible: true,
        //         },
        //         {
        //           id: eMenuItems.tariffs_usage_schemes,
        //           label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_SCHEMES',
        //           link: '/tariffs/tariffs-usage-schemes',
        //           parentId: eMenuItems.tariffs_usage,
        //           visible: true,
        //         },
        //         {
        //           id: eMenuItems.tariffs_usage_scheme_rates,
        //           label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_SCHEME_RATES',
        //           link: '/tariffs/tariffs-usage-scheme-rates',
        //           parentId: eMenuItems.tariffs_usage,
        //           visible: true,
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          id: eMenuItems.tariffs_dropdown,
          label: 'MENUITEMS.TARIFFS.TEXT',
          icon: 'ri-increase-decrease-line',
          isCollapsed: true,
          visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemTariffs, true)
                   && this.modeVisible(false, false, false, true),
          subItems: [
            {
              id: eMenuItems.tariffs_usage_tariffs,
              label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_TARIFFS',
              link: '/tariffs/tariffs-usage',
              parentId: eMenuItems.tariffs_dropdown,
              visible: this.showTariffsUsage,
            },
            {
              id: eMenuItems.tariffs_usage_tariff_zones,
              label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_TARIFFS_ZONES',
              link: '/tariffs/tariffs-usage-zones',
              parentId: eMenuItems.tariffs_dropdown,
              visible: this.showTariffsUsage,
            },
            {
              id: eMenuItems.tariffs_usage_schemes,
              label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_SCHEMES',
              link: '/tariffs/tariffs-usage-schemes',
              parentId: eMenuItems.tariffs_dropdown,
              visible: this.showTariffsUsage,
            },
            {
              id: eMenuItems.tariffs_usage_scheme_rates,
              label: 'MENUITEMS.TARIFFS.LIST.USAGE.USAGE_SCHEME_RATES',
              link: '/tariffs/tariffs-usage-scheme-rates',
              parentId: eMenuItems.tariffs_dropdown,
              visible: this.showTariffsUsage,
            }
          ]
        },
        {
          id: eMenuItems.invoicing_dropdown,
          label: 'MENUITEMS.INVOICING.TEXT',
          icon: 'ri-file-2-line',
          isCollapsed: true,
          visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemInvoice, true)
                   && this.modeVisible(false, false, false, true),
        },
        {
          id: eMenuItems.title_support,
          label: 'MENUITEMS.SUPPORT_TITLE.TEXT',
          isTitle: true,
          visible: this.modeVisible(false, false, false, true),
        },
        {
          id: eMenuItems.support_dropdown,
          label: 'MENUITEMS.SUPPORT_RESOURCES.TEXT',
          icon: 'ri-information-line',
          isCollapsed: true,
          visible: this.modeVisible(false, false, false, true),
          subItems: [
            {
              id: eMenuItems.demo_dropdown,
              label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.TEXT',
              icon: 'ri-play-mini-line',
              parentId: eMenuItems.support_dropdown,
              isCollapsed: true,
              visible: this.showDemonstrations || this.curUser.systemAdmin,
              subItems: [
                {
                  id: eMenuItems.demo_dashboard,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.DASHBOARD',
                  link: '/demos/dashboard',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
                {
                  id: eMenuItems.demo_live_view,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.LIVE_VIEW',
                  link: '/demos/live-view',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
                {
                  id: eMenuItems.demo_user_management,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.USER_MANAGEMENT',
                  link: '/demos/user-management',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
                {
                  id: eMenuItems.demo_sim_management,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.SIM_MANAGEMENT',
                  link: '/demos/sim-management',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
                {
                  id: eMenuItems.demo_manage_change_spend_limit,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.MANAGE_CHANGE_SPEND_LIMIT',
                  link: '/demos/manage-change-spend-limit',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
                {
                  id: eMenuItems.demo_manage_change_tariff_plan,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.MANAGE_CHANGE_TARIFF_PLAN',
                  link: '/demos/manage-change-tariff-plan',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
                {
                  id: eMenuItems.demo_cost_and_usage_reports,
                  label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.DEMOS.LIST.COST_&_USAGE_REPORTS',
                  link: '/demos/cost-and-usage-reports',
                  parentId: eMenuItems.demo_dropdown,
                  visible: true,
                },
              ]
            },
            {
              id: eMenuItems.links_dropdown,
              label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.LINKS.TEXT',
              icon: 'ri-external-link-line',
              parentId: eMenuItems.support_dropdown,
              isCollapsed: true,
              visible: this.showLinks || this.curUser.systemAdmin,
              subItems: [
                {
                  id: eMenuItems.links_nperf,
                  // label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.LINKS.LIST.NPERF',
                  label: this.menuTextLinksNPerf,
                  link: '/links/nperf',
                  parentId: eMenuItems.links_dropdown,
                  visible: this.showLinksNPerf || this.curUser.systemAdmin,
                },
                {
                  id: eMenuItems.links_nperf_map_coverage,
                  // label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.LINKS.LIST.NPERF_MAP_COVERAGE',
                  label: this.menuTextLinksNPerfMapCoverage,
                  link: '/links/nperf-map-coverage',
                  parentId: eMenuItems.links_dropdown,
                  visible: this.showLinksNPerfMapCoverage || this.curUser.systemAdmin,
                },
                {
                  id: eMenuItems.links_nperf_map_speed,
                  // label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.LINKS.LIST.NPERF_MAP_SPEED',
                  label: this.menuTextLinksNPerfMapSpeed,
                  link: '/links/nperf-map-speed',
                  parentId: eMenuItems.links_dropdown,
                  visible: this.showLinksNPerfMapSpeed || this.curUser.systemAdmin,
                },
                {
                  id: eMenuItems.links_nperf_map_speed,
                  // label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.LINKS.LIST.NPERF_MAP_5G',
                  label: this.menuTextLinksNPerfMap5G,
                  link: '/links/nperf-map-5g',
                  parentId: eMenuItems.links_dropdown,
                  visible: this.showLinksNPerfMap5G || this.curUser.systemAdmin,
                },
              ]
            },
            {
              id: eMenuItems.support_page,
              label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.SUPPORT_PAGE.TEXT',
              link: '/support/support-page',
              icon: 'ri-information-line',
              visible: this.supportPlansEnabled && this.componentAccessUserService.hasAccessGuid(AccessGuids.FormSupportPage, true),
            },
            {
              id: eMenuItems.support_ticket_hub,
              label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.TICKET_HUB.TEXT',
              link: '/support/ticket-hub',
              icon: 'ri-coupon-2-line',
              visible: this.showTickets || this.curUser.systemAdmin,
            },
            {
              id: eMenuItems.support_help,
              label: 'MENUITEMS.SUPPORT_RESOURCES.LIST.HELP.TEXT',
              separatorBefore: true,
              link: '/support/support-help',
              icon: 'ri-coupon-2-line',
              visible: this.showHelp || this.curUser.systemAdmin,
            },
          ]
        },
        // {
        //   id: eMenuItems.demo_dropdown,
        //   label: 'MENUITEMS.DEMOS.TEXT',
        //   icon: 'ri-play-mini-line',
        //   isCollapsed: true,
        //   visible: this.showDemonstrations || this.currUser.systemAdmin,
        //   subItems: [
        //     {
        //       id: eMenuItems.demo_dashboard,
        //       label: 'MENUITEMS.DEMOS.LIST.DASHBOARD',
        //       link: '/demos/dashboard',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //     {
        //       id: eMenuItems.demo_live_view,
        //       label: 'MENUITEMS.DEMOS.LIST.LIVE_VIEW',
        //       link: '/demos/live-view',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //     {
        //       id: eMenuItems.demo_user_management,
        //       label: 'MENUITEMS.DEMOS.LIST.USER_MANAGEMENT',
        //       link: '/demos/user-management',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //     {
        //       id: eMenuItems.demo_sim_management,
        //       label: 'MENUITEMS.DEMOS.LIST.SIM_MANAGEMENT',
        //       link: '/demos/sim-management',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //     {
        //       id: eMenuItems.demo_manage_change_spend_limit,
        //       label: 'MENUITEMS.DEMOS.LIST.MANAGE_CHANGE_SPEND_LIMIT',
        //       link: '/demos/manage-change-spend-limit',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //     {
        //       id: eMenuItems.demo_manage_change_tariff_plan,
        //       label: 'MENUITEMS.DEMOS.LIST.MANAGE_CHANGE_TARIFF_PLAN',
        //       link: '/demos/manage-change-tariff-plan',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //     {
        //       id: eMenuItems.demo_cost_and_usage_reports,
        //       label: 'MENUITEMS.DEMOS.LIST.COST_&_USAGE_REPORTS',
        //       link: '/demos/cost-and-usage-reports',
        //       parentId: eMenuItems.demo_dropdown,
        //       visible: true,
        //     },
        //   ]
        // },
        // {
        //   id: eMenuItems.links_dropdown,
        //   label: 'MENUITEMS.LINKS.TEXT',
        //   icon: 'ri-external-link-line',
        //   isCollapsed: true,
        //   visible: this.showLinks || this.currUser.systemAdmin,
        //   subItems: [
        //     {
        //       id: eMenuItems.links_nperf,
        //       // label: 'MENUITEMS.LINKS.LIST.NPERF',
        //       label: this.menuTextLinksNPerf,
        //       link: '/links/nperf',
        //       parentId: eMenuItems.links_dropdown,
        //       visible: this.showLinksNPerf || this.currUser.systemAdmin,
        //     },
        //     {
        //       id: eMenuItems.links_nperf_map_coverage,
        //       // label: 'MENUITEMS.LINKS.LIST.NPERF_MAP_COVERAGE',
        //       label: this.menuTextLinksNPerfMapCoverage,
        //       link: '/links/nperf-map-coverage',
        //       parentId: eMenuItems.links_dropdown,
        //       visible: this.showLinksNPerfMapCoverage || this.currUser.systemAdmin,
        //     },
        //     {
        //       id: eMenuItems.links_nperf_map_speed,
        //       // label: 'MENUITEMS.LINKS.LIST.NPERF_MAP_SPEED',
        //       label: this.menuTextLinksNPerfMapSpeed,
        //       link: '/links/nperf-map-speed',
        //       parentId: eMenuItems.links_dropdown,
        //       visible: this.showLinksNPerfMapSpeed || this.currUser.systemAdmin,
        //     },
        //     {
        //       id: eMenuItems.links_nperf_map_speed,
        //       // label: 'MENUITEMS.LINKS.LIST.NPERF_MAP_5G',
        //       label: this.menuTextLinksNPerfMap5G,
        //       link: '/links/nperf-map-5g',
        //       parentId: eMenuItems.links_dropdown,
        //       visible: this.showLinksNPerfMap5G || this.currUser.systemAdmin,
        //     },
        //   ]
        // },
        // {
        //   id: eMenuItems.support_ticket_hub,
        //   label: 'MENUITEMS.TICKET_HUB.TEXT',
        //   link: '/support/ticket-hub',
        //   icon: 'ri-coupon-2-line',
        //   visible: this.showTickets || this.currUser.systemAdmin,
        // },
        {
          id: eMenuItems.title_settings,
          label: 'MENUITEMS.SETTINGS_TITLE.TEXT',
          isTitle: true,
          visible: (this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfig)
                    || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdmin)
                    || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminCreditLimitManagement)
                    || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTriggeredAlerts)
                   )
                   && this.modeVisible(false, true, true, true),
        },
        {
          id: eMenuItems.configuration_dropdown,
          label: 'MENUITEMS.CONFIGURATION.TEXT',
          icon: 'ri-settings-2-line',
          isCollapsed: true,
          visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfig)
                   && this.modeVisible(false, true, true, true),
          subItems: [
            {
              id: eMenuItems.configuration_screen_defaults,
              label: 'MENUITEMS.CONFIGURATION.LIST.SCREENDEFAULTS',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigScreenDefaults),
              subItems: [
                {
                  id: eMenuItems.configuration_screen_defaults_base,
                  label: 'MENUITEMS.CONFIGURATION.LIST.SCREENDEFAULTS_BASE',
                  link: '/configuration/config-screen-defaults-base',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.GridScreenDefaultsBase, true),
                },
                {
                  id: eMenuItems.configuration_screen_defaults_company_actual,
                  label: 'MENUITEMS.CONFIGURATION.LIST.SCREENDEFAULTS_COMPANY_ACTUAL',
                  link: '/configuration/config-screen-defaults-company-actual',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.GridScreenDefaultsCompanyActual, true),
                },
                {
                  id: eMenuItems.configuration_screen_defaults_company,
                  label: 'MENUITEMS.CONFIGURATION.LIST.SCREENDEFAULTS_COMPANY',
                  link: '/configuration/config-screen-defaults-company',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_screen_defaults_user_actual,
                  label: 'MENUITEMS.CONFIGURATION.LIST.SCREENDEFAULTS_USER_ACTUAL',
                  link: '/configuration/config-screen-defaults-user-actual',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.GridScreenDefaultsUserActual, true),
                },
                {
                  id: eMenuItems.configuration_screen_defaults_user,
                  label: 'MENUITEMS.CONFIGURATION.LIST.SCREENDEFAULTS_USER',
                  link: '/configuration/config-screen-defaults-user',
                  visible: true,
                },
              ]
            },
            {
              id: eMenuItems.configuration_account_managers,
              label: 'MENUITEMS.CONFIGURATION.LIST.ACCOUNTMANAGERS',
              link: '/configuration/config-account-managers',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.supportPlansEnabled,
            },
            {
              id: eMenuItems.communication_config,
              label: 'MENUITEMS.COMM_CONFIG.TEXT',
              parentId: eMenuItems.configuration_dropdown,
              link: '/communication/config',
              visible: this.showCommConfig &&
                       this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemCommConfig),
            },
            {
              id: eMenuItems.configuration_components_dropdown,
              label: 'MENUITEMS.APPLICATION_COMPONENTS.TEXT',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigComponents),
              subItems: [
                {
                  id: eMenuItems.configuration_components_containers,
                  label: 'MENUITEMS.APPLICATION_COMPONENTS.LIST.APP_COMPONENT_CONTAINERS',
                  link: '/web-components/web-component-containers',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_components,
                  label: 'MENUITEMS.APPLICATION_COMPONENTS.LIST.APP_COMPONENTS',
                  link: '/web-components/web-components',
                  visible: true,
                },
              ]
            },
            {
              id: eMenuItems.configuration_country_groups,
              label: 'MENUITEMS.CONFIGURATION.LIST.COUNTRY_GROUPS',
              link: '/configuration/config-country-groups',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigCountryGroups),
            },
            {
              id: eMenuItems.configuration_licences_dropdown,
              label: 'MENUITEMS.CONFIGURATION.LIST.LICENCES',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigLicences),
              subItems: [
                {
                  id: eMenuItems.configuration_licences_system,
                  label: 'MENUITEMS.CONFIGURATION.LIST.LICENCES_SYSTEM',
                  link: '/configuration/config-licences-system',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigLicencesSystem),
                },
                {
                  id: eMenuItems.configuration_licences_company_allocated,
                  label: 'MENUITEMS.CONFIGURATION.LIST.LICENCES_COMPANY_ALLOCATED',
                  link: '/configuration/config-licences-company-allocated',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigLicencesCompanyAllocated),
                },
                {
                  id: eMenuItems.configuration_licences_company_visible,
                  label: 'MENUITEMS.CONFIGURATION.LIST.LICENCES_COMPANY_VISIBLE',
                  link: '/configuration/config-licences-company-visible',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigLicencesCompanyVisible),
                },
              ]
            },
            {
              id: eMenuItems.configuration_mapping,
              label: 'MENUITEMS.CONFIGURATION.LIST.MAPPING',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigMapping),
              subItems: [
                {
                  id: eMenuItems.configuration_mapping_world_maps,
                  label: 'MENUITEMS.CONFIGURATION.LIST.WORLDMAPS',
                  link: '/configuration/config-mapping-world-maps',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_mapping_world_zones,
                  label: 'MENUITEMS.CONFIGURATION.LIST.WORLDZONES',
                  link: '/configuration/config-mapping-world-zones',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_mapping_countries,
                  label: 'MENUITEMS.CONFIGURATION.LIST.COUNTRIES',
                  link: '/configuration/config-mapping-countries',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_mapping_mapped_zones,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MAPPEDZONES',
                  link: '/configuration/config-mapping-mapped-zones',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_mapping_mapped_countries,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MAPPEDCOUNTRIES',
                  link: '/configuration/config-mapping-mapped-countries',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_mapping_addresses,
                  label: 'MENUITEMS.CONFIGURATION.LIST.ADDRESSES',
                  link: '/configuration/config-mapping-addresses',
                  visible: true,
                }
              ]
            },
            {
              id: eMenuItems.configuration_mdm_devices,
              label: 'MENUITEMS.CONFIGURATION.LIST.MDM_DEVICES',
              link: '/device-management/mdm-devices',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigMdmDevices),
            },
            {
              id: eMenuItems.configuration_partner_links,
              label: 'MENUITEMS.CONFIGURATION.LIST.PARTNER_LINKS',
              link: '/configuration/config-partner-links',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.FormPartnerClientLinks, true),
            },
            {
              id: eMenuItems.configuration_products,
              label: 'MENUITEMS.CONFIGURATION.LIST.PRODUCTS',
              link: '/configuration/config-products',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigProducts),
            },
            {
              id: eMenuItems.configuration_reports,
              label: 'MENUITEMS.CONFIGURATION.LIST.REPORTS',
              link: '/configuration/config-reports',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigReports),
            },
            {
              id: eMenuItems.configuration_system,
              label: 'MENUITEMS.CONFIGURATION.LIST.SYSTEM',
              link: '/configuration/config-system',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigSystem),
            },
            {
              id: eMenuItems.configuration_types,
              label: 'MENUITEMS.CONFIGURATION.LIST.TYPES',
              parentId: eMenuItems.configuration_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemConfigTypes),
              subItems: [
                {
                  id: eMenuItems.configuration_types_audit,
                  label: 'MENUITEMS.CONFIGURATION.LIST.AUDIT',
                  link: '/configuration/config-types-audit',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_billing_service,
                  label: 'MENUITEMS.CONFIGURATION.LIST.BILLINGSERVICE',
                  link: '/configuration/config-types-billing-service',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_brand,
                  label: 'MENUITEMS.CONFIGURATION.LIST.BRAND',
                  link: '/configuration/config-types-brand',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_charge,
                  label: 'MENUITEMS.CONFIGURATION.LIST.CHARGE',
                  link: '/configuration/config-types-charge',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_communication,
                  label: 'MENUITEMS.CONFIGURATION.LIST.COMMUNICATION',
                  link: '/configuration/config-types-communication',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_communication_delivery_status,
                  label: 'MENUITEMS.CONFIGURATION.LIST.COMMUNICATION_DELIVERY_STATUS',
                  link: '/configuration/config-types-communication-delivery-status',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_company,
                  label: 'MENUITEMS.CONFIGURATION.LIST.COMPANY',
                  link: '/configuration/config-types-company',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_company_file,
                  label: 'MENUITEMS.CONFIGURATION.LIST.COMPANY_FILE',
                  link: '/configuration/config-types-company-file',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_currency,
                  label: 'MENUITEMS.CONFIGURATION.LIST.CURRENCY',
                  link: '/configuration/config-types-currency',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_currency_symbol,
                  label: 'MENUITEMS.CONFIGURATION.LIST.CURRENCYSYMBOL',
                  link: '/configuration/config-types-currency-symbol',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_data_weight,
                  label: 'MENUITEMS.CONFIGURATION.LIST.DATAWEIGHT',
                  link: '/configuration/config-types-data-weight',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_delivery,
                  label: 'MENUITEMS.CONFIGURATION.LIST.DELIVERY',
                  link: '/configuration/config-types-delivery',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_device,
                  label: 'MENUITEMS.CONFIGURATION.LIST.DEVICE',
                  link: '/configuration/config-types-device',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_download_file,
                  label: 'MENUITEMS.CONFIGURATION.LIST.DOWNLOADFILE',
                  link: '/configuration/config-types-download-file',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_language,
                  label: 'MENUITEMS.CONFIGURATION.LIST.LANGUAGE',
                  link: '/configuration/config-types-language',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_licence,
                  label: 'MENUITEMS.CONFIGURATION.LIST.LICENCE',
                  link: '/configuration/config-types-licence',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_manufacturer,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MANUFACTURER',
                  link: '/configuration/config-types-manufacturer',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_mdm_compliance_issue,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MDM_COMPLIANCE_ISSUE',
                  link: '/configuration/config-types-mdm-compliance-issue',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_mdm_device,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MDM_DEVICE',
                  link: '/configuration/config-types-mdm-device',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_mdm_device_eol_source,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MDM_DEVICES_EOL_SOURCE',
                  link: '/configuration/config-types-mdm-device-end-of-life-source',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_mdm_device_eos_source,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MDM_DEVICES_EOS_SOURCE',
                  link: '/configuration/config-types-mdm-device-end-of-support-source',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_mdm_status,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MDM_STATUS',
                  link: '/configuration/config-types-mdm-status',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_message,
                  label: 'MENUITEMS.CONFIGURATION.LIST.MESSAGE',
                  link: '/configuration/config-types-message',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_occupation,
                  label: 'MENUITEMS.CONFIGURATION.LIST.OCCUPATION',
                  link: '/configuration/config-types-occupation',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_order_status,
                  label: 'MENUITEMS.CONFIGURATION.LIST.ORDER_STATUS',
                  link: '/configuration/config-types-order-status',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_payment_method,
                  label: 'MENUITEMS.CONFIGURATION.LIST.PAYMENT_METHODS',
                  link: '/configuration/config-types-payment',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_payment_term,
                  label: 'MENUITEMS.CONFIGURATION.LIST.PAYMENT_TERMS',
                  link: '/configuration/config-types-payment-term',
                  visible: true,
                },
                // {
                //   id: eMenuItems.configuration_types_portal,
                //   label: 'MENUITEMS.CONFIGURATION.LIST.PORTAL',
                //   link: '/configuration/config-types-portal',
                //   visible: true,
                // },
                {
                  id: eMenuItems.configuration_types_recurring,
                  label: 'MENUITEMS.CONFIGURATION.LIST.RECURRING',
                  link: '/configuration/config-types-recurring',
                  visible: true,
                },
                // {
                //   id: eMenuItems.configuration_types_rounding,
                //   label: 'MENUITEMS.CONFIGURATION.LIST.ROUNDING',
                //   link: '/configuration/config-types-rounding',
                //   visible: true,
                // },
                {
                  id: eMenuItems.configuration_types_support_plan,
                  label: 'MENUITEMS.CONFIGURATION.LIST.SUPPORTPLAN',
                  link: '/configuration/config-types-support-plan',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_tariff,
                  label: 'MENUITEMS.CONFIGURATION.LIST.TARIFF',
                  link: '/configuration/config-types-tariff',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_tariff_band_level,
                  label: 'MENUITEMS.CONFIGURATION.LIST.TARIFFBANDLEVEL',
                  link: '/configuration/config-types-tariff-band-level',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_ticket_issue,
                  label: 'MENUITEMS.CONFIGURATION.LIST.TICKETISSUE',
                  link: '/configuration/config-types-ticket-issue',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_ticket_priority,
                  label: 'MENUITEMS.CONFIGURATION.LIST.TICKETPRIORITY',
                  link: '/configuration/config-types-ticket-priority',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_user_link,
                  label: 'MENUITEMS.CONFIGURATION.LIST.USERLINK',
                  link: '/configuration/config-types-user-link',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_webhook,
                  label: 'MENUITEMS.CONFIGURATION.LIST.WEBHOOK',
                  link: '/configuration/config-types-webhook',
                  visible: true,
                },
                {
                  id: eMenuItems.configuration_types_access,
                  label: 'MENUITEMS.CONFIGURATION.LIST.ACCESS',
                  link: '/configuration/config-types-access',
                  visible: true,
                }                
              ]
            },
          ]
        },
        {
          id: eMenuItems.system_admin_dropdown,
          label: 'MENUITEMS.SYSTEMADMIN.TEXT',
          icon: 'ri-admin-line',
          isCollapsed: true,
          visible: (this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdmin)
                    || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminCreditLimitManagement)
                    || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTriggeredAlerts)
                   )
                   && this.modeVisible(true, true, true, true),
          subItems: [
            {
              id: eMenuItems.system_admin_overview,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.ADMIN_OVERVIEW',
              link: '/system-admin/admin-overview',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminOverview),
            },
            {
              id: eMenuItems.system_admin_api_management,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.API_MANAGEMENT',
              link: '/system-admin/api-management',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminApiManagement),
            },
            {
              id: eMenuItems.system_admin_audit_dropdown,
              label: 'MENUITEMS.CONFIGURATION.LIST.AUDIT',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminAudit),
              subItems: [
                {
                  id: eMenuItems.system_admin_audit_sms,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.AUDIT_SMS',
                  link: '/system-admin/sms-audit',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminSMSAudit),
                },
                {
                  id: eMenuItems.system_admin_audit,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.AUDIT_SYSTEM',
                  link: '/system-admin/audit',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminAudit),
                },
              ]
            },
            {
              id: eMenuItems.system_admin_credit_limits,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.CREDIT_LIMITS',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminCreditLimits)
                       || this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminCreditLimitManagement),
              subItems: [
                {
                  id: eMenuItems.system_admin_credit_limit_alert_recipients,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.CREDIT_LIMIT_ALERT_RECIPIENTS',
                  link: '/system-admin/credit-limit-alert-recipients',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminCreditLimitAlertRecipients),
                },
                {
                  id: eMenuItems.system_admin_credit_limit_management,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.CREDIT_LIMIT_MANAGEMENT',
                  link: '/system-admin/credit-limit-management',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminCreditLimitManagement),
                },
              ]
            },
            {
              id: eMenuItems.system_admin_platform_insights,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.PLATFORM_INSIGHTS',
              link: '/system-admin/platform-insights',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminPlatformInsights, true),
            },
            {
              id: eMenuItems.system_admin_system_locks,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.SYSTEM_LOCKS',
              link: '/system-admin/system-locks',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminSystemLocks),
            },
            {
              id: eMenuItems.system_admin_teams,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.TEAMS',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTeams, true),
              subItems: [
                {
                  id: eMenuItems.system_admin_teams_calls,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.TEAMS_CALLS',
                  link: '/system-admin/teams',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTeams, true),
                },
                {
                  id: eMenuItems.system_admin_teams_statuses,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.TEAMS_STATUSES',
                  link: '/system-admin/teams-statuses',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTeamsStatuses, true),
                },
              ]
            },
            {
              id: eMenuItems.system_admin_triggered_alerts,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.TRIGGERED_ALERTS',
              link: '/system-admin/triggered-alerts',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTriggeredAlerts),
            },
            {
              id: eMenuItems.system_admin_unresolved_mobile,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.UNRESOLVED_MOBILE',
              link: '/system-admin/unresolved-mobile',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminUnresolvedMobile),
            },
            {
              id: eMenuItems.system_admin_user_dropdown,
              label: 'MENUITEMS.SYSTEMADMIN.LIST.USER',
              parentId: eMenuItems.system_admin_dropdown,
              visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminUser),
              subItems: [
                {
                  id: eMenuItems.system_admin_user_browser_info,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.USERBROWSERINFO',
                  link: '/system-admin/user-browser-info',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminUserBrowserInfo),
                },
                {
                  id: eMenuItems.system_admin_user_client_info,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.USERCLIENTINFO',
                  link: '/system-admin/user-client-info',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminUserClientInfo),
                },
                {
                  id: eMenuItems.system_admin_user_sessions,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.USERSESSIONS',
                  link: '/system-admin/user-sessions',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminUserSessions),
                },
                {
                  id: eMenuItems.system_admin_transfer_user_sim,
                  label: 'MENUITEMS.SYSTEMADMIN.LIST.TRANSFER_USERS_SIM',
                  link: '/system-admin/transfers-user-sim',
                  visible: this.componentAccessUserService.hasAccessGuid(AccessGuids.MenuItemSystemAdminTransferUserSims),
                },
              ]
            },
          ]
        },
        
        //Template
        //////////
        {
          id: 8,
          label: 'MENUITEMS.APPS.TEXT',
          icon: 'ri-apps-2-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
      
            {
              id: 9,
              label: 'MENUITEMS.APPS.LIST.CALENDAR',
              isCollapsed: true,
              parentId: 8,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 9,
                  label: 'MENUITEMS.APPS.LIST.MAINCALENDAR',
                  link: '/calendar',
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 9,
                  label: 'MENUITEMS.APPS.LIST.MONTHGRID',
                  link: '/month-grid',
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 10,
              label: 'MENUITEMS.APPS.LIST.CHAT',
              link: '/chat',
              parentId: 8,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 11,
              label: 'MENUITEMS.APPS.LIST.EMAIL',
              parentId: 8,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 13,
                  label: 'MENUITEMS.APPS.LIST.MAILBOX',
                  link: '/mailbox',
                  parentId: 11,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 14,
                  label: 'MENUITEMS.APPS.LIST.MAILTEMPLATES',
                  parentId: 11,
                  visible: this.showTemplateMenuItems,
                  subItems: [
                    {
                      id: 13,
                      label: 'MENUITEMS.APPS.LIST.BASICACTION',
                      link: '/email-basic',
                      parentId: 14,
                      visible: this.showTemplateMenuItems,
                    },
                    {
                      id: 13,
                      label: 'MENUITEMS.APPS.LIST.ECOMMERCEACTION',
                      link: '/email-ecommerce',
                      parentId: 14,
                      visible: this.showTemplateMenuItems,
                    },
                  ]
                }
              ]
            },
            {
              id: 12,
              label: 'MENUITEMS.APPS.LIST.ECOMMERCE',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 13,
                  label: 'MENUITEMS.APPS.LIST.PRODUCTS',
                  link: '/ecommerce/products',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 14,
                  label: 'MENUITEMS.APPS.LIST.PRODUCTDETAILS',
                  link: '/ecommerce/product-detail',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 15,
                  label: 'MENUITEMS.APPS.LIST.CREATEPRODUCT',
                  link: '/ecommerce/add-product',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 16,
                  label: 'MENUITEMS.APPS.LIST.ORDERS',
                  link: '/ecommerce/orders',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 17,
                  label: 'MENUITEMS.APPS.LIST.ORDERDETAILS',
                  link: '/ecommerce/order-details',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 18,
                  label: 'MENUITEMS.APPS.LIST.CUSTOMERS',
                  link: '/ecommerce/customers',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 19,
                  label: 'MENUITEMS.APPS.LIST.SHOPPINGCART',
                  link: '/ecommerce/cart',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 20,
                  label: 'MENUITEMS.APPS.LIST.CHECKOUT',
                  link: '/ecommerce/checkout',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 21,
                  label: 'MENUITEMS.APPS.LIST.SELLERS',
                  link: '/ecommerce/sellers',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 22,
                  label: 'MENUITEMS.APPS.LIST.SELLERDETAILS',
                  link: '/ecommerce/seller-details',
                  parentId: 12,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 23,
              label: 'MENUITEMS.APPS.LIST.PROJECTS',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 24,
                  label: 'MENUITEMS.APPS.LIST.LIST',
                  link: '/projects/list',
                  parentId: 23,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 25,
                  label: 'MENUITEMS.APPS.LIST.OVERVIEW',
                  link: '/projects/overview',
                  parentId: 23,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 26,
                  label: 'MENUITEMS.APPS.LIST.CREATEPROJECT',
                  link: '/projects/create',
                  parentId: 23,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 27,
              label: 'MENUITEMS.APPS.LIST.TASK',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 28,
                  label: 'MENUITEMS.APPS.LIST.KANBANBOARD',
                  link: '/tasks/kanban',
                  parentId: 27,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 29,
                  label: 'MENUITEMS.APPS.LIST.LISTVIEW',
                  link: '/tasks/list-view',
                  parentId: 27,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 30,
                  label: 'MENUITEMS.APPS.LIST.TASKDETAILS',
                  link: '/tasks/details',
                  parentId: 27,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 31,
              label: 'MENUITEMS.APPS.LIST.CRM',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 32,
                  label: 'MENUITEMS.APPS.LIST.CONTACTS',
                  link: '/crm/contacts',
                  parentId: 31,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 33,
                  label: 'MENUITEMS.APPS.LIST.COMPANIES',
                  link: '/crm/companies',
                  parentId: 31,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 34,
                  label: 'MENUITEMS.APPS.LIST.DEALS',
                  link: '/crm/deals',
                  parentId: 31,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 35,
                  label: 'MENUITEMS.APPS.LIST.LEADS',
                  link: '/crm/leads',
                  parentId: 31,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 36,
              label: 'MENUITEMS.APPS.LIST.CRYPTO',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 37,
                  label: 'MENUITEMS.APPS.LIST.TRANSACTIONS',
                  link: '/crypto/transactions',
                  parentId: 36,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 38,
                  label: 'MENUITEMS.APPS.LIST.BUY&SELL',
                  link: '/crypto/buy-sell',
                  parentId: 36,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 38,
                  label: 'MENUITEMS.APPS.LIST.ORDERS',
                  link: '/crypto/orders',
                  parentId: 36,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 39,
                  label: 'MENUITEMS.APPS.LIST.MYWALLET',
                  link: '/crypto/wallet',
                  parentId: 36,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 40,
                  label: 'MENUITEMS.APPS.LIST.ICOLIST',
                  link: '/crypto/ico',
                  parentId: 36,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 41,
                  label: 'MENUITEMS.APPS.LIST.KYCAPPLICATION',
                  link: '/crypto/kyc',
                  parentId: 36,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 42,
              label: 'MENUITEMS.APPS.LIST.INVOICES',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 43,
                  label: 'MENUITEMS.APPS.LIST.LISTVIEW',
                  link: '/invoices/list',
                  parentId: 42,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 44,
                  label: 'MENUITEMS.APPS.LIST.DETAILS',
                  link: '/invoices/details',
                  parentId: 42,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 45,
                  label: 'MENUITEMS.APPS.LIST.CREATEINVOICE',
                  link: '/invoices/create',
                  parentId: 42,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 46,
              label: 'MENUITEMS.APPS.LIST.SUPPORTTICKETS',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 47,
                  label: 'MENUITEMS.APPS.LIST.LISTVIEW',
                  link: '/tickets/list',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.TICKETDETAILS',
                  link: '/tickets/details',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
            {
              id: 46,
              label: 'MENUITEMS.APPS.LIST.NFTMARKETPLACE',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 47,
                  label: 'MENUITEMS.APPS.LIST.MARKETPLACE',
                  link: '/marletplace/marketplace',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.EXPLORENOW',
                  link: '/marletplace/explore',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.LIVEAUCTION',
                  link: '/marletplace/auction',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.ITEMDETAILS',
                  link: '/marletplace/item-details',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.COLLECTIONS',
                  link: '/marletplace/collections',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.CREATORS',
                  link: '/marletplace/creators',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.RANKING',
                  link: '/marletplace/raking',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.WALLETCONNECT',
                  link: '/marletplace/wallet',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 48,
                  label: 'MENUITEMS.APPS.LIST.CREATENFT',
                  link: '/marletplace/create',
                  parentId: 46,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 49,
              label: 'MENUITEMS.APPS.LIST.FILEMANAGER',
              link: '/file-manager',
              parentId: 8,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 50,
              label: 'MENUITEMS.APPS.LIST.TODO',
              link: '/todo',
              parentId: 8,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 51,
              label: 'MENUITEMS.APPS.LIST.JOBS',
              parentId: 8,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 52,
                  label: 'MENUITEMS.APPS.LIST.STATISTICS',
                  link: '/jobs/statistics',
                  parentId: 51,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 53,
                  label: 'MENUITEMS.APPS.LIST.JOBLISTS',
                  visible: this.showTemplateMenuItems,
                  subItems: [
                    {
                      id: 54,
                      label: 'MENUITEMS.APPS.LIST.LIST',
                      link: '/jobs/list',
                      parentId: 53,
                      visible: this.showTemplateMenuItems,
                    },
                    {
                      id: 55,
                      label: 'MENUITEMS.APPS.LIST.GRID',
                      link: '/jobs/grid',
                      parentId: 53,
                      visible: this.showTemplateMenuItems,
                    },
                    {
                      id: 56,
                      label: 'MENUITEMS.APPS.LIST.OVERVIEW',
                      link: '/jobs/overview',
                      parentId: 53,
                      visible: this.showTemplateMenuItems,
                    }
                  ]
                },
                {
                  id: 57,
                  label: 'MENUITEMS.APPS.LIST.CANDIDATELISTS',
                  isCollapsed: true,
                  visible: this.showTemplateMenuItems,
                  subItems: [
                    {
                      id: 58,
                      label: 'MENUITEMS.APPS.LIST.LISTVIEW',
                      link: '/jobs/listview',
                      parentId: 57,
                      visible: this.showTemplateMenuItems,
                    },
                    {
                      id: 59,
                      label: 'MENUITEMS.APPS.LIST.GRIDVIEW',
                      link: '/jobs/gridview',
                      parentId: 57,
                      visible: this.showTemplateMenuItems,
                    }
                  ]
                },
                {
                  id: 60,
                  label: 'MENUITEMS.APPS.LIST.APPLICATION',
                  link: '/jobs/application',
                  parentId: 51,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 61,
                  label: 'MENUITEMS.APPS.LIST.NEWJOB',
                  link: '/jobs/newjob',
                  parentId: 51,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 62,
                  label: 'MENUITEMS.APPS.LIST.COMPANIESLIST',
                  link: '/jobs/companies-list',
                  parentId: 51,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 63,
                  label: 'MENUITEMS.APPS.LIST.JOBCATEGORIES',
                  link: '/jobs/job-categories',
                  parentId: 51,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 64,
              label: 'MENUITEMS.APPS.LIST.APIKEY',
              link: '/apikey',
              parentId: 8,
              visible: this.showTemplateMenuItems,
            },
          ]
        },
        {
          id: 54,
          label: 'MENUITEMS.PAGES.TEXT',
          isTitle: true,
          visible: this.showTemplateMenuItems,
        },
        {
          id: 55,
          label: 'MENUITEMS.AUTHENTICATION.TEXT',
          icon: 'ri-account-circle-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 56,
              label: 'MENUITEMS.AUTHENTICATION.LIST.SIGNIN',
              parentId: 49,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 57,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/signin/basic',
                  parentId: 56,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 58,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/signin/cover',
                  parentId: 56,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 59,
              label: 'MENUITEMS.AUTHENTICATION.LIST.SIGNUP',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 60,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/signup/basic',
                  parentId: 59,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 61,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/signup/cover',
                  parentId: 59,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 62,
              label: 'MENUITEMS.AUTHENTICATION.LIST.PASSWORDRESET',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 63,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/pass-reset/basic',
                  parentId: 62,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 64,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/pass-reset/cover',
                  parentId: 62,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 62,
              label: 'MENUITEMS.AUTHENTICATION.LIST.PASSWORDCREATE',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 63,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/pass-create/basic',
                  parentId: 62,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 64,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/pass-create/cover',
                  parentId: 62,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 65,
              label: 'MENUITEMS.AUTHENTICATION.LIST.LOCKSCREEN',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 66,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/lockscreen/basic',
                  parentId: 65,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 67,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/lockscreen/cover',
                  parentId: 65,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 68,
              label: 'MENUITEMS.AUTHENTICATION.LIST.LOGOUT',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 69,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/logout/basic',
                  parentId: 68,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 70,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/logout/cover',
                  parentId: 68,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 71,
              label: 'MENUITEMS.AUTHENTICATION.LIST.SUCCESSMESSAGE',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 72,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/success-msg/basic',
                  parentId: 71,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 73,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/success-msg/cover',
                  parentId: 71,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 74,
              label: 'MENUITEMS.AUTHENTICATION.LIST.TWOSTEPVERIFICATION',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 75,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.BASIC',
                  link: '/auth/twostep/basic',
                  parentId: 74,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 76,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.COVER',
                  link: '/auth/twostep/cover',
                  parentId: 74,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 77,
              label: 'MENUITEMS.AUTHENTICATION.LIST.ERRORS',
              parentId: 49,
              isCollapsed: true,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 78,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.404BASIC',
                  link: '/auth/errors/404-basic',
                  parentId: 77,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 79,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.404COVER',
                  link: '/auth/errors/404-cover',
                  parentId: 77,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 80,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.404ALT',
                  link: '/auth/errors/404-alt',
                  parentId: 77,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 81,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.500',
                  link: '/auth/errors/page-500',
                  parentId: 77,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 81,
                  label: 'MENUITEMS.AUTHENTICATION.LIST.OFFLINE',
                  link: '/auth/errors/offline',
                  parentId: 77,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
          ]
        },
        {
          id: 82,
          label: 'MENUITEMS.PAGES.TEXT',
          icon: 'ri-pages-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 83,
              label: 'MENUITEMS.PAGES.LIST.STARTER',
              link: '/pages/starter',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 84,
              label: 'MENUITEMS.PAGES.LIST.PROFILE',
              parentId: 82,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 85,
                  label: 'MENUITEMS.PAGES.LIST.SIMPLEPAGE',
                  link: '/pages/profile',
                  parentId: 84,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 86,
                  label: 'MENUITEMS.PAGES.LIST.SETTINGS',
                  link: '/pages/profile-setting',
                  parentId: 84,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 87,
              label: 'MENUITEMS.PAGES.LIST.TEAM',
              link: '/pages/team',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 88,
              label: 'MENUITEMS.PAGES.LIST.TIMELINE',
              link: '/pages/timeline',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 89,
              label: 'MENUITEMS.PAGES.LIST.FAQS',
              link: '/pages/faqs',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 90,
              label: 'MENUITEMS.PAGES.LIST.PRICING',
              link: '/pages/pricing',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 91,
              label: 'MENUITEMS.PAGES.LIST.GALLERY',
              link: '/pages/gallery',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 92,
              label: 'MENUITEMS.PAGES.LIST.MAINTENANCE',
              link: '/pages/maintenance',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 93,
              label: 'MENUITEMS.PAGES.LIST.COMINGSOON',
              link: '/pages/coming-soon',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 94,
              label: 'MENUITEMS.PAGES.LIST.SITEMAP',
              link: '/pages/sitemap',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 95,
              label: 'MENUITEMS.PAGES.LIST.SEARCHRESULTS',
              link: '/pages/search-results',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 96,
              label: 'MENUITEMS.PAGES.LIST.PRIVACYPOLICY',
              link: '/pages/privacy-policy',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 97,
              label: 'MENUITEMS.PAGES.LIST.TERMS&CONDITIONS',
              link: '/pages/terms-condition',
              parentId: 82,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 131,
          label: 'MENUITEMS.LANDING.TEXT',
          icon: 'ri-rocket-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 85,
              label: 'MENUITEMS.LANDING.LIST.ONEPAGE',
              link: '/landing',
              parentId: 84,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 86,
              label: 'MENUITEMS.LANDING.LIST.NFTLANDING',
              link: '/landing/nft',
              parentId: 84,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 87,
              label: 'MENUITEMS.LANDING.LIST.JOB',
              link: '/landing/job',
              parentId: 84,
              visible: this.showTemplateMenuItems,
            },
          ]
        },
        {
          id: 96,
          label: 'MENUITEMS.COMPONENTS.TEXT',
          isTitle: true,
          visible: this.showTemplateMenuItems,
        },
        {
          id: 97,
          label: 'MENUITEMS.BASEUI.TEXT',
          icon: 'ri-pencil-ruler-2-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 98,
              label: 'MENUITEMS.BASEUI.LIST.ALERTS',
              link: '/ui/alerts',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 99,
              label: 'MENUITEMS.BASEUI.LIST.BADGES',
              link: '/ui/badges',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 100,
              label: 'MENUITEMS.BASEUI.LIST.BUTTONS',
              link: '/ui/buttons',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 101,
              label: 'MENUITEMS.BASEUI.LIST.COLORS',
              link: '/ui/colors',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 102,
              label: 'MENUITEMS.BASEUI.LIST.CARDS',
              link: '/ui/cards',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 103,
              label: 'MENUITEMS.BASEUI.LIST.CAROUSEL',
              link: '/ui/carousel',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 104,
              label: 'MENUITEMS.BASEUI.LIST.DROPDOWNS',
              link: '/ui/dropdowns',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 105,
              label: 'MENUITEMS.BASEUI.LIST.GRID',
              link: '/ui/grid',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 106,
              label: 'MENUITEMS.BASEUI.LIST.IMAGES',
              link: '/ui/images',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 107,
              label: 'MENUITEMS.BASEUI.LIST.TABS',
              link: '/ui/tabs',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 108,
              label: 'MENUITEMS.BASEUI.LIST.ACCORDION&COLLAPSE',
              link: '/ui/accordions',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 109,
              label: 'MENUITEMS.BASEUI.LIST.MODALS',
              link: '/ui/modals',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 111,
              label: 'MENUITEMS.BASEUI.LIST.PLACEHOLDERS',
              link: '/ui/placeholder',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 112,
              label: 'MENUITEMS.BASEUI.LIST.PROGRESS',
              link: '/ui/progress',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 113,
              label: 'MENUITEMS.BASEUI.LIST.NOTIFICATIONS',
              link: '/ui/notifications',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 114,
              label: 'MENUITEMS.BASEUI.LIST.MEDIAOBJECT',
              link: '/ui/media',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 115,
              label: 'MENUITEMS.BASEUI.LIST.EMBEDVIDEO',
              link: '/ui/video',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 116,
              label: 'MENUITEMS.BASEUI.LIST.TYPOGRAPHY',
              link: '/ui/typography',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 117,
              label: 'MENUITEMS.BASEUI.LIST.LISTS',
              link: '/ui/list',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 117,
              label: 'MENUITEMS.BASEUI.LIST.LINKS',
              link: '/ui/links',
              badge: {
                variant: 'bg-success',
                text: 'MENUITEMS.DASHBOARD.BADGE',
              },
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 118,
              label: 'MENUITEMS.BASEUI.LIST.GENERAL',
              link: '/ui/general',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
      
            {
              id: 119,
              label: 'MENUITEMS.BASEUI.LIST.RIBBONS',
              link: '/ui/ribbons',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 120,
              label: 'MENUITEMS.BASEUI.LIST.UTILITIES',
              link: '/ui/utilities',
              parentId: 97,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 121,
          label: 'MENUITEMS.ADVANCEUI.TEXT',
          icon: 'ri-stack-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 122,
              label: 'MENUITEMS.ADVANCEUI.LIST.SWEETALERTS',
              link: '/advance-ui/sweetalerts',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 124,
              label: 'MENUITEMS.ADVANCEUI.LIST.SCROLLBAR',
              link: '/advance-ui/scrollbar',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 126,
              label: 'MENUITEMS.ADVANCEUI.LIST.TOUR',
              link: '/advance-ui/tour',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 127,
              label: 'MENUITEMS.ADVANCEUI.LIST.SWIPERSLIDER',
              link: '/advance-ui/swiper',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 128,
              label: 'MENUITEMS.ADVANCEUI.LIST.RATTINGS',
              link: '/advance-ui/ratings',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 129,
              label: 'MENUITEMS.ADVANCEUI.LIST.HIGHLIGHT',
              link: '/advance-ui/highlight',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 130,
              label: 'MENUITEMS.ADVANCEUI.LIST.SCROLLSPY',
              link: '/advance-ui/scrollspy',
              parentId: 121,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 131,
          label: 'MENUITEMS.WIDGETS.TEXT',
          icon: 'ri-honour-line',
          link: '/widgets',
          visible: this.showTemplateMenuItems,
        },
        {
          id: 132,
          label: 'MENUITEMS.FORMS.TEXT',
          icon: 'ri-file-list-3-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 133,
              label: 'MENUITEMS.FORMS.LIST.BASICELEMENTS',
              link: '/forms/basic',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 134,
              label: 'MENUITEMS.FORMS.LIST.FORMSELECT',
              link: '/forms/select',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 135,
              label: 'MENUITEMS.FORMS.LIST.CHECKBOXS&RADIOS',
              link: '/forms/checkboxs-radios',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 136,
              label: 'MENUITEMS.FORMS.LIST.PICKERS',
              link: '/forms/pickers',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 137,
              label: 'MENUITEMS.FORMS.LIST.INPUTMASKS',
              link: '/forms/masks',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 138,
              label: 'MENUITEMS.FORMS.LIST.ADVANCED',
              link: '/forms/advanced',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 139,
              label: 'MENUITEMS.FORMS.LIST.RANGESLIDER',
              link: '/forms/range-sliders',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 140,
              label: 'MENUITEMS.FORMS.LIST.VALIDATION',
              link: '/forms/validation',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 141,
              label: 'MENUITEMS.FORMS.LIST.WIZARD',
              link: '/forms/wizard',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 142,
              label: 'MENUITEMS.FORMS.LIST.EDITORS',
              link: '/forms/editors',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 143,
              label: 'MENUITEMS.FORMS.LIST.FILEUPLOADS',
              link: '/forms/file-uploads',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 144,
              label: 'MENUITEMS.FORMS.LIST.FORMLAYOUTS',
              link: '/forms/layouts',
              parentId: 132,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 145,
          label: 'MENUITEMS.TABLES.TEXT',
          icon: 'ri-layout-grid-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 146,
              label: 'MENUITEMS.TABLES.LIST.BASICTABLES',
              link: '/tables/basic',
              parentId: 145,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 147,
              label: 'MENUITEMS.TABLES.LIST.GRIDJS',
              link: '/tables/gridjs',
              parentId: 145,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 148,
              label: 'MENUITEMS.TABLES.LIST.LISTJS',
              link: '/tables/listjs',
              parentId: 145,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 149,
          label: 'MENUITEMS.CHARTS.TEXT',
          icon: 'ri-pie-chart-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 150,
              label: 'MENUITEMS.CHARTS.LIST.APEXCHARTS',
              parentId: 149,
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 151,
                  label: 'MENUITEMS.CHARTS.LIST.LINE',
                  link: '/charts/apex-line',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 152,
                  label: 'MENUITEMS.CHARTS.LIST.AREA',
                  link: '/charts/apex-area',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 153,
                  label: 'MENUITEMS.CHARTS.LIST.COLUMN',
                  link: '/charts/apex-column',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 154,
                  label: 'MENUITEMS.CHARTS.LIST.BAR',
                  link: '/charts/apex-bar',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 155,
                  label: 'MENUITEMS.CHARTS.LIST.MIXED',
                  link: '/charts/apex-mixed',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 156,
                  label: 'MENUITEMS.CHARTS.LIST.TIMELINE',
                  link: '/charts/apex-timeline',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 157,
                  label: 'MENUITEMS.CHARTS.LIST.RANGEAREA',
                  link: '/charts/range-area',
                  badge: {
                    variant: 'bg-success',
                    text: 'MENUITEMS.DASHBOARD.BADGE',
                  },
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 15,
                  label: 'MENUITEMS.CHARTS.LIST.FUNNEL',
                  link: '/charts/funnel',
                  badge: {
                    variant: 'bg-success',
                    text: 'MENUITEMS.DASHBOARD.BADGE',
                  },
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 158,
                  label: 'MENUITEMS.CHARTS.LIST.CANDLSTICK',
                  link: '/charts/apex-candlestick',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 159,
                  label: 'MENUITEMS.CHARTS.LIST.BOXPLOT',
                  link: '/charts/apex-boxplot',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 160,
                  label: 'MENUITEMS.CHARTS.LIST.BUBBLE',
                  link: '/charts/apex-bubble',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 161,
                  label: 'MENUITEMS.CHARTS.LIST.SCATTER',
                  link: '/charts/apex-scatter',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 162,
                  label: 'MENUITEMS.CHARTS.LIST.HEATMAP',
                  link: '/charts/apex-heatmap',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 163,
                  label: 'MENUITEMS.CHARTS.LIST.TREEMAP',
                  link: '/charts/apex-treemap',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 164,
                  label: 'MENUITEMS.CHARTS.LIST.PIE',
                  link: '/charts/apex-pie',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 165,
                  label: 'MENUITEMS.CHARTS.LIST.RADIALBAR',
                  link: '/charts/apex-radialbar',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 166,
                  label: 'MENUITEMS.CHARTS.LIST.RADAR',
                  link: '/charts/apex-radar',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 167,
                  label: 'MENUITEMS.CHARTS.LIST.POLARAREA',
                  link: '/charts/apex-polar',
                  parentId: 150,
                  visible: this.showTemplateMenuItems,
                },
              ]
            },
            {
              id: 168,
              label: 'MENUITEMS.CHARTS.LIST.CHARTJS',
              link: '/charts/chartjs',
              parentId: 149,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 169,
              label: 'MENUITEMS.CHARTS.LIST.ECHARTS',
              link: '/charts/echarts',
              parentId: 149,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 170,
          label: 'MENUITEMS.ICONS.TEXT',
          icon: 'ri-compasses-2-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 171,
              label: 'MENUITEMS.ICONS.LIST.REMIX',
              link: '/icons/remix',
              parentId: 170,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 172,
              label: 'MENUITEMS.ICONS.LIST.BOXICONS',
              link: '/icons/boxicons',
              parentId: 170,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 173,
              label: 'MENUITEMS.ICONS.LIST.MATERIALDESIGN',
              link: '/icons/materialdesign',
              parentId: 170,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 174,
              label: 'MENUITEMS.ICONS.LIST.LINEAWESOME',
              link: '/icons/lineawesome',
              parentId: 170,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 175,
              label: 'MENUITEMS.ICONS.LIST.FEATHER',
              link: '/icons/feather',
              parentId: 170,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 176,
              label: 'MENUITEMS.ICONS.LIST.CRYPTOSVG',
              link: '/icons/icons-crypto',
              parentId: 170,
              visible: this.showTemplateMenuItems,
            },
          ]
        },
        {
          id: 175,
          label: 'MENUITEMS.MAPS.TEXT',
          icon: 'ri-map-pin-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 176,
              label: 'MENUITEMS.MAPS.LIST.GOOGLE',
              link: '/maps/google',
              parentId: 175,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 178,
              label: 'MENUITEMS.MAPS.LIST.LEAFLET',
              link: '/maps/leaflet',
              parentId: 175,
              visible: this.showTemplateMenuItems,
            }
          ]
        },
        {
          id: 179,
          label: 'MENUITEMS.MULTILEVEL.TEXT',
          icon: 'ri-share-line',
          isCollapsed: true,
          visible: this.showTemplateMenuItems,
          subItems: [
            {
              id: 180,
              label: 'MENUITEMS.MULTILEVEL.LIST.LEVEL1.1',
              parentId: 179,
              visible: this.showTemplateMenuItems,
            },
            {
              id: 181,
              label: 'MENUITEMS.MULTILEVEL.LIST.LEVEL1.2',
              visible: this.showTemplateMenuItems,
              subItems: [
                {
                  id: 182,
                  label: 'MENUITEMS.MULTILEVEL.LIST.LEVEL1.LEVEL2.1',
                  parentId: 181,
                  visible: this.showTemplateMenuItems,
                },
                {
                  id: 183,
                  label: 'MENUITEMS.MULTILEVEL.LIST.LEVEL1.LEVEL2.2',
                  parentId: 181,
                  visible: this.showTemplateMenuItems,
                }
              ]
            },
          ]
        }
      ];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }
}
